import { combineReducers } from "redux";
import adminReducer from "./admin";
import authReducer from "./auth";
import checkoutReducer from "./checkout";
import feedbackReducer from "./feedback";
import menuReducer from "./menu";
import stylesReducer from "./styles";
import configReducer from "./config";

const rootReducer = combineReducers({
  auth: authReducer,
  styles: stylesReducer,
  menu: menuReducer,
  checkout: checkoutReducer,
  admin: adminReducer,
  feedback: feedbackReducer,
  config: configReducer,
});

export default rootReducer;
